import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
import { Helmet } from 'react-helmet';


const Blog27 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_27;

    const {title, p} = InfoContent.Blog_27.one;
    const {Ctitle, Cp} = InfoContent.Blog_27.conclusion;
    // const {title2, p2} = InfoContent.Blog_26.two;
    // const {title3, p3} = InfoContent.Blog_26.three;
    // const {title4, p4} = InfoContent.Blog_26.four;
    // const {title5, p5} = InfoContent.Blog_26.five;
    // const {title6, p6} = InfoContent.Blog_26.six;
    // const {title7, p7} = InfoContent.Blog_26.seven;
    // const {title8, p8} = InfoContent.Blog_26.eight;
    

    // const {liss1} = ListContent.Blog_25.L1;
    // const {liss2} = ListContent.Blog_25.L2;
    // const {liss3} = ListContent.Blog_25.L3;
    // const {liss4} = ListContent.Blog_25.L4;
  return (
    <>

        <Helmet>
            <title>
               Gynecologist Hospital in Chembur | Expert Women's & Fertility Care | Acme Fertility
            </title>

            <meta
                name="description"
                content="Looking for a trusted gynecologist hospital in Chembur? Acme Fertility offers expert gynecology, pregnancy care, infertility treatment, and advanced IVF services. Book a consultation with experienced specialists for personalized women's healthcare in Mumbai."
            />

            <meta
                name="keywords"
                content="top ivf hospital in mumbai, top ivf doctors in mumbai, best ivf centre in navi mumbai, highest ivf success rate hospital in india, ivf treatment cost mumbai, best fertility clinic mumbai, ivf specialist near me, fertility treatment mumbai"
            />

            <link
                rel="canonical"
                href="https://www.acmefertility.com/20/BlogDetails"
            />
           
           <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://www.acmefertility.com/"
    },
    "headline": "Gynecologist Hospital in Chembur: Expert Women's Healthcare & Fertility Care",
    "alternativeHeadline": "Expert Gynecology, Pregnancy & Fertility Care at Acme Fertility",
    "description": "Looking for a trusted gynecologist hospital in Chembur? Acme Fertility offers expert gynecology, pregnancy care, infertility treatment, IVF, ICSI, IUI, fertility preservation, and personalized women's healthcare in Mumbai.",
    "image": "https://www.acmefertility.com/images/gynecologist-hospital-chembur.jpg",
    "author": {
      "@type": "Person",
      "name": "Dr. Neelam Bhise",
      "jobTitle": "Consultant Gynecologist & Fertility Specialist",
      "worksFor": {
        "@type": "MedicalOrganization",
        "name": "Acme Fertility"
      }
    },
    "publisher": {
      "@type": "MedicalOrganization",
      "name": "Acme Fertility",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.acmefertility.com/images/logo.png"
      }
    },
    "datePublished": "2026-07-14",
    "dateModified": "2026-07-14",
    "articleSection": [
      "Gynecology",
      "Women's Health",
      "Infertility Treatment",
      "IVF",
      "Pregnancy Care"
    ],
    "keywords": [
      "Gynecologist Hospital in Chembur",
      "Best Infertility Specialist in Mumbai",
      "Top IVF Hospital in Mumbai",
      "Fertility Clinic Hospital Near Me",
      "Women's Healthcare",
      "Pregnancy Care",
      "IVF",
      "IUI",
      "ICSI",
      "PCOS Treatment",
      "Endometriosis",
      "Fibroids",
      "High-Risk Pregnancy"
    ],
    "articleBody": "This article explains how Acme Fertility provides comprehensive gynecology, pregnancy care, infertility diagnosis, IVF, ICSI, IUI, fertility preservation, and personalized reproductive healthcare for women and couples in Chembur, Mumbai.",
    "about": {
      "@type": "MedicalCondition",
      "name": "Female Infertility"
    },
    "audience": {
      "@type": "PeopleAudience",
      "suggestedGender": "Female"
    },
    "inLanguage": "en-IN",
    "isAccessibleForFree": true
  })}
</script>
        </Helmet>

        

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={Ctitle} p={Cp} />
                    {/* <Info title={title2} p={p2} />
                    <Info title={title3} p={p3} />
                    <Info title={title4} p={p4} />
                    
                    <Info title={title5} p={p5} />
                    <Info title={title6} p={p6} />
                    <Info title={title7} p={p7} />
                    
                    <Info title={title8}p={p8}/> */}
                     

                    
             </div>

                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default Blog27